import React, { FC, PropsWithChildren } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { OPERATOR_PANEL_PADDING } from '@components/operatorPanel/constants/operatorPanel.constants';
import { useOperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper/hooks';

export interface HeaderProps extends PropsWithChildren {
  containerStyles?: StyleProp<ViewStyle>;
}

const Header: FC<HeaderProps> = ({ children, containerStyles }) => {
  const { scale } = useOperatorPanelSettingsWrapperContext();

  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: scale(12),
          paddingHorizontal: scale(OPERATOR_PANEL_PADDING),
          width: '100%',
          position: 'relative',
          zIndex: 1000,
        },
        containerStyles,
      ]}
    >
      {children}
    </View>
  );
};

export default Header;
